import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const BHXH = "BHXH";
export const BHYT = "BHYT";
export const DKY_XE = "DKY_XE";
export const GPLX = "GPLX";
export const THUE_CN = "THUE_CN";

export const findRequestLookups = (headers, params) => {
    let query = buildQuery(params, []);
    if (params?.filters?.type?.value) {
        query += `&type=${params?.filters?.type?.value?.trim()}`;
    }
    if (params?.filters?.idNumber?.value) {
        query += `&idNumber=${params?.filters?.idNumber?.value?.trim()}`;
    }
    return axios.get(`${process.env.REACT_APP_REGISTER_OLN_API_URL}/request-lookup/search${query}`, {
        headers,
    });
};
